import shallowProperty from './_shallowProperty.js';

// Internal helper to obtain the `length` property of an object.
export default shallowProperty('length');



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/_getLength.js
// module id = 33
// module chunks = 115